import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { timeout } from "rxjs";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";
import { JwtService } from "../../services/auth/jwt.service";
import { SocketData } from "../../services/web-socket/contract/web-socket.contract";
import { createWSUrl } from "../api.util";
import { GenericApi } from "../generic.api";

type T = {};

@Injectable({
  providedIn: "root",
})
export class WSUserApi extends GenericApi<T> {
  public path = "web-socket-user";

  constructor(
    public httpClient: HttpClient,
    private readonly jwtService: JwtService,
  ) {
    super(httpClient);
  }

  createWS = (topic: string): WebSocketSubject<SocketData> => {
    const socket = webSocket({
      url: createWSUrl(this.path, topic),
      protocol: this.jwtService.getJWTString(),
      deserializer: (msg) => JSON.parse(msg.data),
      serializer: (msg) => JSON.stringify(msg),
    });
    return socket.pipe(timeout(7200000)) as WebSocketSubject<SocketData>; // 120 minutes = 7,200,000 ms
  };
}
